<template>
  <b-container id="people-subview" v-if="accountUsers">
    <loading :show="loading"></loading>

    <b-row align-h="center">
      <b-col cols="12" xs="12" sm="12" md="12" lg="10" class="mb-2">
        <div class="panel--invisible text-center">
          <h2>{{$t('account:people-header', { accountName: $store.state.account.name })}}</h2>
          <h5 v-if="accountUsers.length < 5">{{$t('account:invite__minimum-info', { invitationsNeeded: 5 - accountUsers.length })}}</h5>
        </div>
        <div class="panel" style="margin-bottom: 0; padding: 2rem;">
        <b-form @submit.prevent="sendInvitations">
          <b-form-group :label="$t('account:invite__label')"
                        label-for="exampleInput1"
                        :description="$t('account:invite__description')">
            <b-form-textarea id="addresses"
                             v-model="addresses"
                             :placeholder="$t('account:invite__placeholder')"
                             :rows="3">
            </b-form-textarea>
          </b-form-group>

          <b-button type="submit" :disabled="!addresses" variant="primary">{{$t('account:invite__cta')}}</b-button>
        </b-form>
        <br/>
        <b-alert variant="success" dismissible :show="successCount > 0">
          <p><span v-if="successCount > 1">{{$t('account:invite-multiple-success', { successCount: successCount })}}</span><span v-else>{{$t('account:invite-success')}}</span></p>
        </b-alert>
        <b-alert variant="warning" dismissible :show="errorAddresses.length > 0">{{$t('account:invite-error')}}: <span v-for="(address, index) in errorAddresses" :key="index">{{address}}<span v-if="index !== errorAddresses.length - 1">, </span></span>. {{$t('account:invite-error-help')}}</b-alert>

        <div class="table-responsive mt-3">
          <table class="table b-table b-table-stacked-lg">
            <tbody>
            <tr v-for="user in accountUsers" :key="user._id" style="line-height: 2.5rem; border-bottom: 1px solid #f3f3f3;" :class="{'suspended': user.suspended}">
              <td style="font-weight: bold;">
                <a v-if="user.name" :href="'MAILTO:' + user.email">{{user.name}} &lt;{{user.email}}&gt;</a>
                <a v-else :href="'MAILTO:' + user.email">{{user.email}}</a>
              </td>
              <td style="color: #888;">
                <span v-if="!user.validated && user.suspended !== true">{{$t('account:status-invited')}} {{user.invitedAt | moment("from", "now") }}</span>
                <span v-if="user.validated && user.suspended !== true">{{$t('account:status-joined')}} {{user.validated | moment("from", "now") }}</span>
                <span v-if="user.suspended === true">{{$t('account:suspended')}}</span>
              </td>
              <td>
                <div v-if="!user.suspended">
                  <b-button @click="suspendUser(user._id)" variant="danger">{{$t('account:suspend')}}</b-button>
                </div>
                <div v-else>
                  <b-button @click="unsuspendUser(user._id)" variant="success">{{$t('account:resume')}}</b-button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row align-h="center">
      <b-col cols="12" xs="12" sm="12" md="10" lg="7" class="mb-2">
        <div class="panel p-4 mt-3 mb-5">
          <h3>Remove account</h3>
          <p>If you wish to stop using Bubblo+ and ask for your team's data to be removed, please click the button below. A confirmation email will be sent to you before we remove your account and the data associated with it.</p>
          <p>
            <b-button variant="danger" @click.self="sendRemovalRequest" :disabled="removalRequest.loading" :class="{ 'loading': removalRequest.loading }" v-if="!removalRequest.done">Please remove our account</b-button>
            <b-alert :show="removalRequest.done" variant="success">Your request was sent. An email confirmation will be sent to you before removing your account.</b-alert>
          </p>
        </div>
      </b-col>
    </b-row> -->

  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import loading from '../common/loading/LoadingOverlay'

export default {
  name: 'AccountPeople',
  data () {
    return {
      removalRequest: {
        loading: false,
        done: false
      },
      loading: false,
      fields: [{ key: 'status', sortable: true, label: 'Status' }, { key: 'name', sortable: true, label: 'Name' }, { key: 'email', sortable: true, label: 'Email' }],
      addresses: '',
      errorAddresses: [],
      successCount: null
    }
  },
  components: { loading },
  mounted: function () {
    if (this.$store.state.user.name && this.$store.state.account.name) {
      this.message = this.$store.state.user.name + ' would like you to join Bubblo+ to help make ' + this.$store.state.account.name + ' a better place to work'
    }
  },
  computed: {
    ...mapGetters(['accountUsers'])
  },
  methods: {
    sendInvitations () {
      this.successCount = null
      this.errorAddresses = []
      const cleanedAddresses = this.addresses.trim().split(/[\s,;]+/).map(email => {
        const e = email.trim().toLowerCase().replace(/[<>]/g, '')
        if (e.length > 0 && /(.+)@(.+){2,}\.(.+){2,}/.test(e) !== false) {
          return e
        } else {
          return null
        }
      }).filter(e => typeof e === 'string' && e !== '')
      this.axios.post('/account/users', { emails: cleanedAddresses }).then((response) => {
        this.addresses = ''
        this.errorAddresses = response.data.errors
        this.successCount = response.data.successes
        this.$store.dispatch('loadAccount')
      }).catch((err) => {
        throw err
      })
    },
    suspendUser (userId) {
      this.loading = true
      this.axios.put(`account/users/${userId}`, { suspended: true })
        .then(res => {
          this.loading = false
          this.$store.dispatch('loadAccount')
        })
        .catch(e => {
          this.loading = false
          throw e
        })
    },
    unsuspendUser (userId) {
      this.loading = true
      this.axios.put(`account/users/${userId}`, { suspended: false })
        .then(res => {
          this.loading = false
          this.$store.dispatch('loadAccount')
        })
        .catch(e => {
          this.loading = false
          throw e
        })
    },
    sendRemovalRequest () {
      this.removalRequest.loading = true
      const self = this
      return new Promise((resolve, reject) => {
        this.axios.post('/feedback/open', { message: 'Account Owner has requested their account to be removed. Please confirm via email.' }).then(response => {
          self.removalRequest.loading = false
          self.removalRequest.done = true
          resolve()
        }).catch(err => {
          self.removalRequest.loading = false
          reject(err)
        })
      })
    }

  }
}
</script>

<style lang="scss">
  tr.suspended {
    background: #eee;
  }
</style>
